import { OptionStatus } from '@cds/betting-offer';
import { EventOption } from '@frontend/sports/betting-offer/feature/model';

export function isOptionVisible(option: EventOption): boolean {
    return option.online || option.status === OptionStatus.Visible;
}
